/* jshint esversion: 6 */
/* jshint ignore:start */
import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const Success = () => {
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {

        sessionStorage.setItem("Paymentstatus", "PaymentDone");
        const pages = sessionStorage.getItem("pages");

        if (pages === "0") {
            navigate("/wallet");
        } else if (pages === "1") {
            navigate("/cart");
        } else {
            navigate("/order-history");
        }

    }, [location]);

    return null;
};

export default Success;

export const Cancel = () => {

    const navigate = useNavigate();

    useEffect(() => {

        sessionStorage.setItem("Paymentstatus", "Paymentfaild");

        const pages = sessionStorage.getItem("pages");
        if (pages === "0") {
            navigate("/wallet");
        } else if (pages === "1") {
            navigate("/cart");
        } else {
            navigate("/order-history");
        }

    }, [navigate]);

    return null;
};
/* jshint ignore:end */